module.exports = __webpack_public_path__ + "f7230ac5cca14564b3095e15c1b18a29.pdf";